import React from 'react';
import FormViewModal from 'components/common/Modals/FormViewModal';
import { ReturnCreditsStyles } from './ReturnCreditsDialog.styles';
import { withStyles } from '@material-ui/core/styles';
import { DataGrid } from 'devextreme-react';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import { IFormViewModelHandle } from 'components/common/Modals/FormViewModal.properties';
import { HotKeys } from 'react-hotkeys';
import { useMemoizedKeyHandlers } from 'utils/hooks';
import DynamicDataGrid from 'components/common/DataGridDevEx/DynamicDataGrid';
import { columns } from './constants';
import { IReturnCreditDialogProperties } from './ReturnCreditsDialog.properties';

const getActions = (onClose) => {
    return [
        {
            title: 'Close',
            iconName: 'Cancel',
            isDefault: true,
            listener: () => {
                if (onClose) {
                    onClose();
                }
            },
        },
    ];
};

const ReturnCreditsDialog = (props: IReturnCreditDialogProperties) => {
    const { classes, open, onClose, initialValues } = props;

    const gridRef = React.useRef<DataGrid>();
    const formViewModalRef = React.useRef<IFormViewModelHandle>();
    const filterButtonRef = React.useRef<HTMLButtonElement>();

    const actions = React.useMemo(
        () => getActions(onClose),
        [onClose]
    );

    const onEscape = React.useCallback(
        () => {
            if (onClose) {
                onClose();
            }
        },
        [onClose]
    );

    const handlers = useMemoizedKeyHandlers({
        Escape: onEscape,
    });

    const focusFilterButton = React.useCallback(
        () => {
            if (filterButtonRef.current) {
                filterButtonRef.current.focus();
            }
        },
        [filterButtonRef.current]
    );

    const focusGrid = React.useCallback(
        () => {
            setTimeout(
                () => {
                    gridRef.current?.instance.focus();
                },
                0
            );
        },
        [gridRef.current]
    );

    return (
        <div>
            <HotKeys handlers={handlers}>
                <FormViewModal
                    open={open}
                    title='Return For Credits'
                    loading={false}
                    innerRef={formViewModalRef}
                    onActionsTabOut={focusFilterButton}
                    onActionShiftTabOut={focusGrid}
                    modalContent={
                        <div className={classes.ReturnCreditsContainer}>
                            <DynamicDataGrid
                                columns={columns}
                                allowHeaderFilting={false}
                                allowUpdating={false}
                                allowDelete={false}
                                actionButtonsVisibility={false}
                                gridProps={{
                                    dataSource: initialValues,
                                    dataGridRef: gridRef,
                                    sorting: { mode: 'single' },
                                    disableDrillDown: false,
                                    disableEditing: false,
                                    disableDelete: false,
                                }}
                            >

                            </DynamicDataGrid >
                        </div>
                    }
                    actions={actions}
                    dialogActionsButtons={true}
                    dialogActionsShadow={false}
                />
            </HotKeys>
        </div>
    );
};

export default withStyles(ReturnCreditsStyles)(React.memo(ReturnCreditsDialog));
